import React from 'react';
import { FormattedMessage } from 'react-intl';

import messages from '../messages';

// noinspection JSValidateTypes
const InsuranceOptionLabel = () => <FormattedMessage {...messages.insurance} />;

export default InsuranceOptionLabel;
